import { Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { MutationResult } from 'apollo-angular';
import { LoginV2Mutation } from '../../generated/eveportal-api/graphql';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../shared/error-dialog/error-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  username = '';
  password = '';
  // deviceName = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private tokenService: TokenService,
    private dialog: MatDialog, // ✅ inject here
    private snack: MatSnackBar
  ) {
    if (
      tokenService.isRefreshTokenValid() &&
      tokenService.isEveportalJwtTokenValid()
    ) {
      this.router.navigate(['/home']);
    }
  }

  onLogin() {
    let detectedEnv: 'dev' | 'beta' | 'prod' = 'prod';
    let realUsername = this.username;

    if (this.username.startsWith('dev:')) {
      detectedEnv = 'dev';
      realUsername = this.username.replace(/^dev:/, '');
    } else if (this.username.startsWith('beta:')) {
      detectedEnv = 'beta';
      realUsername = this.username.replace(/^beta:/, '');
    }

    environment.setEnvironment(detectedEnv);
    console.log('🔍 Detected environment:', detectedEnv);

    this.authService
      .login(realUsername, this.password, environment.deviceName)

      .subscribe({
        next: (response: MutationResult<LoginV2Mutation>) => {
          const token = response.data?.loginV2;
          if (!token) {
            this.dialog.open(ErrorDialogComponent, {
              data: { message: 'Invalid username or password.' },
            });
            return;
          }
          this.tokenService.setRefreshToken(token);
          console.log('🔑 Login successful!');
        },
        error: (err: any) => {
          console.error('❌ Login error:', err);
          const errorMessage =
            'Login failed: ' +
            (err instanceof Error ? err.message : 'Unknown error');
          this.snack.open(errorMessage, 'Dismiss');
        },
      });
  }
}
